export class UpdateAvailabilityPayload {
    constructor(data, availability) {
        this.id = data.id;
        this.variantId = data.variantId;
        this.warehouse = {};
        this.warehouse.id = data.id;
        this.availability = availability;
    }
}
